export default "__VITE_ASSET__BFbMrmuK__"